import { generateLottieDefaultData } from 'widgets/LottieWidget/LottieWidget.helper';

import { GUTTER_SIZE, THUMBNAIL_WIDTH } from '../../../InfiniteGrid/InfiniteGrid.config';
import { LottieMetadata } from './GifsWidgetPack.types';

/**
 * A function required by the react-window to calculate a width of each column.
 * In out current use case, we just need to return a const number.
 *
 * @returns a number
 */
export const calculateColumnWidth = () => {
  return THUMBNAIL_WIDTH + GUTTER_SIZE;
};

/**
 * A helper function for generating widgetData for Lottie widget from LottieMetadata
 *
 * @returns widgetData
 */
export const createLottieWidgetData = (hit: LottieMetadata) => {
  return generateLottieDefaultData(hit.file);
};
